export function trackHistoryStateChange(onPushState, onReplaceState, onPopState) {
    if (history.onPushState === undefined) {
        const pushState = history.pushState;
        history.pushState = function () {
            const r = pushState.apply(history, arguments);
            history.onPushState();
            return r;
        };
    }
    ;
    history.onPushState = onPushState;
    if (history.onReplaceState === undefined) {
        const replaceState = history.replaceState;
        history.replaceState = function () {
            const r = replaceState.apply(history, arguments);
            history.onReplaceState();
            return r;
        };
    }
    ;
    history.onReplaceState = onReplaceState;
    window.onpopstate = onPopState;
}
const EVENT_TYPE = "appChangeEvent";
const MODULE_CHANGE_EVENT_TYPE = "moduleChangeEvent";
const EVENT_APP_SCOPES_CHANGED = "appScopesChangedEvent";
export function trackAppLocationChange(callback) {
    console.debug(`Register app location listener`);
    document.addEventListener(EVENT_TYPE, (event) => {
        event && event.detail && callback(event.detail);
    }, { capture: true });
}
export function reportAppLocation(location) {
    document.dispatchEvent(new CustomEvent(EVENT_TYPE, { detail: location }));
}
export function reportAppScopesChanges(newScopes) {
    const eventDetails = { scopes: newScopes };
    document.dispatchEvent(new CustomEvent(EVENT_APP_SCOPES_CHANGED, { detail: eventDetails }));
}
export function trackAppScopesChange(callback) {
    const eventHandler = (event) => {
        event && event.detail && callback(event.detail);
    };
    document.addEventListener(EVENT_APP_SCOPES_CHANGED, eventHandler, {
        capture: true,
    });
    return eventHandler;
}
export function untrackAppScopesChange(handler) {
    document.removeEventListener(EVENT_APP_SCOPES_CHANGED, handler, {
        capture: true,
    });
}
export function trackActiveModuleChange(callback) {
    const handler = (event) => {
        event && event.detail && callback(event.detail);
    };
    document.addEventListener(MODULE_CHANGE_EVENT_TYPE, handler, {
        capture: true,
    });
    return handler;
}
export function untrackActiveModuleChange(handler) {
    document.removeEventListener(MODULE_CHANGE_EVENT_TYPE, handler, {
        capture: true,
    });
}
export function reportActiveModule(module) {
    document.dispatchEvent(new CustomEvent(MODULE_CHANGE_EVENT_TYPE, {
        detail: module,
    }));
}
export function reportActiveSection(app, section) {
    document.dispatchEvent(new CustomEvent(MODULE_CHANGE_EVENT_TYPE, {
        detail: {
            app: app,
            section: section,
        },
    }));
}
//# sourceMappingURL=location-change.js.map